export default __webpack_public_path__ + "static/media/Rohan.b96daddf.jpg";